import React from "react";
import AnchorLink from "./AnchorLink";

export default function TableOfContentsItem({ name, url}) {
  return (
    <li className="mb-0 py-1">
      <AnchorLink name={name} href={url} className="text-red relative px-4 md:py-2 md:before:hidden font-bold rounded whitespace-nowrap hover:bg-yellow hover:bg-opacity-50 active:bg-opacity-75" />
    </li>
  );
}
